<template>
    <div class="main-container">
        <span>Advisories</span>
        <PhQuestion
            :size="20"
            weight="fill"
            v-tooltip.top="{
                value: `Advisories are informational notes about potential<br> privacy risks or situations to be aware of. They don't<br> require action, just helpful context to keep you informed.`,
                escape: false,
            }"
        />
    </div>
</template>
<script setup lang="ts"></script>
<style lang="scss" scoped>
.main-container {
    @apply flex items-center w-full gap-2;

    svg {
        @apply text-zinc-300 cursor-pointer hover:text-zinc-600;
    }

    span {
        @apply text-zinc-950 font-inter text-base font-semibold leading-normal;
    }
}
</style>
